"use client";
import React from "react";
import { CaretRight } from "./svg-icons";
import { BoxSmall, BoxLarge, BoxOne, BoxTwo, FedEXBox } from "./box";
import Image from "next/image";
import { LinkButton } from "@/components/ui/button-simple";

const ComingSoon = () => {
  return (
    <section className="bg-white">
      <div className="landing-container">
        {/* Section Title */}
        <div className="pb-12 pt-8 text-center sm:py-12 md:py-16">
          <h2 className="landing-section-header mx-auto max-w-[351px] sm:max-w-[541px] md:max-w-[564px]">
            A new e-commerce <br />
            experience coming soon
          </h2>
          <p className="landing-section-subheader mx-auto mb-[1.88rem] max-w-[26.265rem] md:mb-[1.81rem] lg:mb-[3.84rem]">
            Get ready for seamless shopping, exclusive deals, and more.
          </p>

          {/* visible on large screens */}
          <div className="mx-auto hidden w-full gap-4 md:flex md:gap-6">
            <div className="flex flex-1 flex-col gap-4 md:gap-6">
              <BoxOne
                src="/landing/coming-soon/vector-1.svg"
                alt="Bulk ordering made easy"
                title="Bulk ordering made easy"
                description="Order any quantity without restrictions, empowering your business to scale effortlessly."
              />

              <BoxTwo
                src="/landing/coming-soon/vector-2.svg"
                alt="Seamless"
                title="Seamless, from onboarding, to checkout"
                description="Enjoy a hassle-free journey from sign-up to payment"
              />

              <FedEXBox src="/landing/coming-soon/fedx.png" />
            </div>

            <div className="flex flex-1 flex-col gap-4 md:gap-6">
              <BoxLarge className="hidden lg:block">
                <div className="relative mt-auto h-full w-full">
                  <Image
                    src="/landing/coming-soon/laptop.png"
                    alt="laptop"
                    fill
                    className="rounded-lg object-cover"
                    priority
                  />
                </div>
              </BoxLarge>
              <BoxLarge className="md:block lg:hidden">
                <div className="relative mt-auto h-full w-full">
                  <Image
                    src="/landing/coming-soon/laptop-wide.png"
                    alt="laptop"
                    fill
                    className="rounded-lg object-cover"
                  />
                </div>
              </BoxLarge>
              <BoxTwo
                src="/landing/coming-soon/vector-3.svg"
                alt="Extensive product selection"
                title="Extensive product selection"
                description="Access a wide range of inventory, from the latest electronics to essential components, all in one place"
              />
            </div>

            <div className="flex flex-1 flex-col gap-4 md:gap-6">
              <BoxOne
                src="/landing/coming-soon/vector-4.svg"
                alt="Sales and discounts"
                title="Sales and discounts"
                description="Limited-time offers on top brand electronics."
              />

              <BoxOne
                src="/landing/coming-soon/vector-5.svg"
                alt="Global wire transfer"
                title="Global wire transfer"
                description="Shop with peace of mind, pay securely via Wire transfer or ACH from anywhere in the world."
              />

              <BoxTwo
                className="bg-system-grey"
                src="/landing/coming-soon/vector-6.svg"
                alt="Enterprise"
                title="Launching this summer"
                description="Experience a new standard in enterprise commerce."
                link={
                  <LinkButton
                    href="#join-waitlist"
                    className="mt-4 inline-flex items-center gap-1 text-[15px] leading-[21px] text-system-primary"
                  >
                    Sign up for early access <CaretRight />
                  </LinkButton>
                }
              />
            </div>
          </div>

          {/* visible on small screens */}
          <div className="flex flex-col gap-4 md:hidden">
            <div className="flex flex-col gap-4 sm:flex-row">
              <BoxOne
                src="/landing/coming-soon/vector-1.svg"
                alt="Bulk ordering made easy"
                title="Bulk ordering made easy"
                description="Order any quantity without restrictions, empowering your business to scale effortlessly."
              />
              <BoxSmall className="p-0">
                <div className="relative mt-auto h-full w-full">
                  <Image
                    src="/landing/coming-soon/laptop-medium.png"
                    alt="laptop"
                    fill
                    className="rounded-lg object-cover"
                    priority
                  />
                </div>
              </BoxSmall>
            </div>
            <div className="flex flex-col gap-4 sm:flex-row">
              <BoxOne
                src="/landing/coming-soon/vector-4.svg"
                alt="Sales and discounts"
                title="Sales and discounts"
                description="Limited-time offers on top brand electronics."
              />
              <BoxOne
                src="/landing/coming-soon/vector-2.svg"
                alt="Seamless"
                title="Seamless, from onboarding, to checkout"
                description="Enjoy a hassle-free journey from sign-up to payment"
              />
            </div>
            <div className="flex flex-col gap-4 sm:flex-row">
              <FedEXBox src="/landing/coming-soon/fedx.png" />
              <BoxOne
                src="/landing/coming-soon/vector-5.svg"
                alt="Global wire transfer"
                title="Global wire transfer"
                description="Shop with peace of mind, pay securely via Wire transfer or ACH from anywhere in the world."
              />
            </div>
            <div className="flex flex-col gap-4 sm:flex-row">
              <BoxOne
                src="/landing/coming-soon/vector-3.svg"
                alt="Extensive product selection"
                title="Extensive product selection"
                description="Access a wide range of inventory, from the latest electronics to essential components, all in one place"
              />
              <BoxOne
                className="bg-system-grey"
                src="/landing/coming-soon/vector-6.svg"
                alt="Enterprise"
                title="Launching this summer"
                description="Experience a new standard in enterprise commerce."
                link={
                  <LinkButton
                    href="#join-waitlist"
                    className="mt-4 inline-flex items-center gap-1 text-[15px] leading-[21px] text-system-primary"
                  >
                    Sign up for early access <CaretRight />
                  </LinkButton>
                }
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ComingSoon;
